import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BuildChildren from 'utils/BuildChildren';
import { priceFormatter } from 'utils/Numbers';
import { buildProductStructuredData } from 'utils/StructuredData';
import AffirmContainer from 'containers/AffirmContainer/AffirmContainer';
import classes from './CardProductC.module.scss';

const CardProductC = (props) => {
  const {
    displayName,
    content,
    subtitle,
    price,
    originalPrice,
    button,
    color,
    isAffirmEligible,
  } = props;

  const borderColor = `border-${color}`;

  // A separate element for topBorder is needed because borders are bevelled and this needs to span entire top border
  return (
    <div className={classNames(classes.container, borderColor)}>
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{ __html: buildProductStructuredData(props) }}
      />
      <div className={classes.wrapper}>
        {displayName &&
          <h3
            className={classes.displayName}
            dangerouslySetInnerHTML={{ __html: displayName }}
          />}
        {subtitle &&
          <h4
            className={classes.subtitle}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />}
        {price >= 0 &&
          <div className={classes.price}>
            {priceFormatter(price)}
          </div>}
        {originalPrice > price &&
          <div className={classes.originalPrice}>
            {priceFormatter(originalPrice)}
          </div>}
        {price >= 0 &&
          <div className={classes.affirmMessage}>
            <AffirmContainer price={price} isAffirmEligible={isAffirmEligible} className={classes.affirmMessage} />
          </div>}
        {content &&
          <div
            className={classes.content}
            dangerouslySetInnerHTML={{ __html: content }}
          />}
        {button &&
          <div className={classes.itemsContainer}>
            <div className={classes.button}>
              {BuildChildren(button)}
            </div>
          </div>}
      </div>
    </div>
  );
};

CardProductC.propTypes = {
  /**
   * Product title that displays at the top of the card
  */
  displayName: PropTypes.string,
  /**
   * Product content
  */
  content: PropTypes.string,
  /**
   * Product subtitle
  */
  subtitle: PropTypes.string,
  /**
   * Product price
  */
  price: PropTypes.number,
  /**
   * Product original price
  */
  originalPrice: PropTypes.number,
  /**
   * Add to cart button of the product
  */
  button: PropTypes.object,
  /**
   * Top border color of the card
  */
  color: PropTypes.string,
  /**
   * Can you use affirm on this product
  */
  isAffirmEligible: PropTypes.bool,
};

export default CardProductC;
